module.exports = __webpack_public_path__ + "static/img/login-title.cc351957.png";